import { useMemo } from "react";
import { FormRadioGroupInput } from "form";
import { useStressTypes } from "stores";

const StressTypeInput = ({ isViewMode }) => {
  const { stressTypes } = useStressTypes();
  const stressTypesOptions = useMemo(
    () =>
      stressTypes?.map(({ name, shortName }) => ({
        value: name,
        label: shortName,
      })) || [],
    [stressTypes],
  );
  return (
    <FormRadioGroupInput
      name="stressType"
      isViewMode={isViewMode}
      options={stressTypesOptions}
    />
  );
};

export default StressTypeInput;
